<template>
	<div class="StudyDelete" v-if="currentTab">
		<h2 class="left-align">Study Delete</h2>
		<div v-if="hasDeletePermission">
			<p class="p2 left-align">Do you want to delete this study?</p>
			<p class="p2 left-align">Deleting a study does the following:</p>
			<ul class="left-align">
				<li><v-icon color="#be4800">warning</v-icon>Removes all respondent accounts</li>
				<li><v-icon color="#be4800">warning</v-icon>Deletes all data collected for this study</li>
				<li><v-icon color="#be4800">warning</v-icon>Deletes the study for all study staff</li>
				<li><v-icon color="#be4800">warning</v-icon>Releases the study abbreviation so that it can be used by another researcher</li>
			</ul>
			<p class="p2 left-align delete-warning-text"><strong>Deleted data cannot be retrieved.</strong></p>
			<v-btn class="btn-default" text @click="onOpenCancel()">Cancel</v-btn>
			<v-btn class="btn-default" text @click="onOpenDelete()"><v-icon >delete</v-icon>Delete Study</v-btn>
		</div>
		<div v-else>
			<h3 class="left-align">Only the study creator can delete a study. If this study needs to be deleted please contact {{selectedStudy.primaryEmail}}.</h3>
		</div>
		<!-- Delete confirmation pop up -->
		<foe-dialog
      v-model="deleteDialog"
			:dialogW="deleteDialog"
      persistent
      max-width="600"
			class="delete-study-dialog"
    >
      <v-card class="study-delete-confirm-card">
        <v-card-title class="headline">
          Confirm Delete Study
        </v-card-title>
        <v-card-text>
					<p class="p2 left-align">
						Are you sure you want to delete the “{{selectedStudy.studyName}}” ({{selectedStudy.studyId}}) study?  All study data and respondent information will be deleted.
						<br><br>
						<strong>This action cannot be undone.</strong> Proceed?
					</p>
				</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
						ref="firstFocusable"
            text
						class="btn-default"
            @click="deleteDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
						:loading="isDeleting"
						class="btn-default"
            @click="onDelete()"
          >
            <v-icon >delete</v-icon>Delete Study
          </v-btn>
        </v-card-actions>
      </v-card>
    </foe-dialog>
		<!-- Cancel pop up -->
		<foe-dialog
      v-model="cancelDialog"
			:dialogW="cancelDialog"
      persistent
			max-width="600px"
			class="cancel-dialog"
    >
      <v-card class="cancel-confirm-card">
        <v-card-title>Cancel</v-card-title>
        <v-card-text>Are you sure you want to cancel?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
					<v-btn
            text
						class="btn-default"
            @click="cancelDialog = false"
          >
            No
          </v-btn>
          <v-btn
            text
						class="btn-default"
            @click="onCancel()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </foe-dialog>
	</div>
</template>

<script>
import { utilityService } from '@/services/utilityService.js';
export default {
	name: 'StudyDelete',
	props: {
	},
	data: () => ({
		deleteDialog: false,
		cancelDialog: false,
		isDeleting: false
	}),
	mounted () {
	},
	methods: {
		async checkTabMatch ({ tabIndex, subTabIndex } = {}) {
			var tabsPos = await utilityService.getTabsPositionByName('Delete Study', this.$studyTabConfig);
			if (tabsPos.tabPos === tabIndex && tabsPos.subtabPos === subTabIndex) {
				this.$refs.firstFocusable.focus();
			}
		},
		onOpenCancel () {
			this.cancelDialog = true;
		},
		onCancel () {
			window.location.reload();
		},
		onOpenDelete () {
			this.deleteDialog = true;
		},
		async onDelete () {
			const me = this;
			this.isDeleting = true;

			await this.$store.dispatch('deleteStudy', this.selectedStudy.studyUuid)
				.then(function (response) {
					if (response) {
						me.$store.dispatch('changeUpdateStatus', { status: 'deleted-study' });
						me.$router.push('/landing');
					} else {
						console.log('delete failed');
					}
				})
				.catch(function (error) {
					console.log(error);
				});

			this.isDeleting = false;
		}
	},
	computed: {
		selectedStudy: function () {
			// If the selectedStudy changes, the radio buttons and checkbox properties need to be updated.
			return this.$store.getters.getSelectedStudy;
		},
		currentTab: function () {
			const tabPosition = {
				tabIndex: parseInt(this.$store.getters.getCurrentStudyTabIndex),
				subTabIndex: parseInt(this.$store.getters.getCurrentStudySubTabIndex)
			};

			this.checkTabMatch(tabPosition);

			return tabPosition;
		},
		hasDeletePermission: function () {
			return this.selectedStudy.primaryEmail.toLowerCase() === this.$store.getters.getUserInfo.userName.toLowerCase();
		}
	}
}
</script>

<style>
</style>
